
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://duihvfqarjwrcyttypxd.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR1aWh2ZnFhcmp3cmN5dHR5cHhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyNDk5MDEsImV4cCI6MjA1ODgyNTkwMX0.cGy0kiPR_nGGEiDj_RGAQgSQslNSsVrFsr2biQBr3h0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
